/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Builder_Approvers_DescriptionInputs */



/**
* | output |
* | --- |
* | "People who may approve this agent's paused runs without being organization admins. Leave empty to fall back to the person who started the run." |
*
* @param {Agent_Builder_Approvers_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_builder_approvers_description = /** @type {((inputs?: Agent_Builder_Approvers_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Builder_Approvers_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Personen, die pausierte Läufe dieses Agenten freigeben dürfen, ohne Organisationsadmin zu sein. Leer lassen, um auf die Person zurückzufallen, die den Lauf gestartet hat.")
	return /** @type {LocalizedString} */ ("People who may approve this agent's paused runs without being organization admins. Leave empty to fall back to the person who started the run.")
});